import React, { useState, useEffect } from "react";

export default function Disclaimer({ onAccept }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => { setMounted(true); }, []);

  return (
    <div style={{ ...styles.overlay, opacity: mounted ? 1 : 0 }}>
      <div style={{ ...styles.card, transform: mounted ? 'scale(1)' : 'scale(0.9)', opacity: mounted ? 1 : 0 }}>
        <div style={styles.icon}>🙏</div>
        <h2 style={styles.title}>Welcome to Mokshapatra</h2>

        <p style={styles.text}>
          This app is designed as a tool for personal growth and spiritual
          exploration. While we hope it supports your journey, please remember
          it's not a replacement for professional mental health care.
        </p>

        <p style={styles.text}>
          If you're experiencing a crisis, please reach out to a qualified
          professional.
        </p>

        <button onClick={onAccept} style={styles.button}>
          Continue Your Journey
        </button>

        <p style={styles.smallText}>
          By continuing, you agree to use this app for personal exploration.
        </p>
      </div>

      <style>{`
        @keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
      `}</style>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed", inset: 0,
    background: "#0D0D2B",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 10001, padding: "20px",
    transition: "opacity 0.4s ease-out",
  },
  card: {
    background: "#1E1145",
    border: "1px solid rgba(201,146,10,0.25)",
    borderRadius: "20px", padding: "50px 40px",
    maxWidth: "520px", width: "100%",
    boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
    textAlign: "center",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  icon: {
    fontSize: "60px", marginBottom: "20px",
    animation: "float 3s ease-in-out infinite",
  },
  title: {
    fontFamily: '"Cinzel", serif',
    fontSize: "26px", fontWeight: "700",
    color: "#C9920A",
    marginBottom: "24px", marginTop: 0,
  },
  text: {
    fontSize: "15px", lineHeight: "1.7",
    color: "rgba(245,240,232,0.7)",
    marginBottom: "16px", textAlign: "left",
  },
  button: {
    background: "#C9920A",
    color: "#0D0D2B",
    border: "none", borderRadius: "12px",
    padding: "16px 40px",
    fontSize: "16px", fontWeight: "700",
    cursor: "pointer", width: "100%",
    marginTop: "8px",
    fontFamily: '"Lato", sans-serif',
  },
  smallText: {
    fontSize: "12px", color: "rgba(245,240,232,0.3)",
    marginTop: "18px", lineHeight: "1.5",
  },
};
